// extracted by mini-css-extract-plugin
export default {"container":"FieldDecorator__container--KDOtx","visible":"FieldDecorator__visible--3e3in","warning":"FieldDecorator__warning--R1qd8","label":"FieldDecorator__label--DDGB+"};